export { useCommonCriteria } from './useCommonCriteria';
